import React from "react";
import { Icon } from "./Icon";
import { displayInitial, displayName, roleMeta } from "../lib/userDisplay";
import { userStorePinLabel } from "../theme";
import { hrefForAppPage, shouldHandleAsSpaNav } from "../routing/paths";

export function SideDrawer({ open, onClose, user, lang, onLogout, activeTheme, navItems, page, setPage }) {
  return (
    <>
      <div className={`drawer-overlay ${open ? "drawer-open" : ""}`} onClick={onClose} />
      <div className={`drawer-panel ${open ? "drawer-open" : ""}`}>
        <div style={{ padding: "20px 16px 14px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 10 }}>
          <img
            src={activeTheme.logoSrc}
            alt={activeTheme.name}
            style={{ width: 48, height: 48, borderRadius: 12, objectFit: "cover" }}
          />
          <div>
            <div className="brand-name">{activeTheme.name}</div>
            <div className="brand-sub">Operations</div>
          </div>
        </div>
        <div className="sidebar-user" style={{ margin: "12px 14px 0" }}>
          <div className="sidebar-user-row">
            <div className="user-avatar">{displayInitial(user)}</div>
            <div className="sidebar-user-copy">
              <div className="user-name" title={displayName(user)}>{displayName(user)}</div>
              <span className="user-role-badge">{lang === "gr" ? roleMeta(user).labelGr : roleMeta(user).label}</span>
            </div>
          </div>
          <div className="user-store" style={{ marginTop: 8 }}>📍 {userStorePinLabel(user)}</div>
        </div>
        <nav className="sidebar-nav drawer-nav" aria-label={lang === "gr" ? "Μενού" : "Menu"}>
          {(navItems || []).map((item) => (
            <a
              key={item.id}
              href={hrefForAppPage(item.id)}
              className={`nav-button ${page === item.id ? "nav-active" : ""}`}
              onClick={(e) => {
                if (!shouldHandleAsSpaNav(e)) return;
                e.preventDefault();
                if (item.onClick) item.onClick();
                else setPage(item.id);
                onClose();
              }}
            >
              <Icon name={item.icon} size={17} />
              {lang === "gr" ? item.labelGr : item.label}
              {item.badge > 0 && <span className="nav-notification">{item.badge}</span>}
            </a>
          ))}
        </nav>
        <div style={{ padding: 14, borderTop: "1px solid var(--border)" }}>
          <button type="button" className="signout-button" style={{ width: "100%", justifyContent: "center" }} onClick={onLogout}>
            <Icon name="logout" size={15} />{lang === "gr" ? "Αποσύνδεση" : "Sign Out"}
          </button>
        </div>
      </div>
    </>
  );
}